import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much life insurance do I need?",
    a: "A common rule of thumb is 10–15 times your annual income, but the right amount depends on your debts, dependents, future goals (college, mortgage payoff), and existing savings. Darryl will help you calculate a number that actually fits your life.",
  },
  {
    q: "Is the quote really free?",
    a: "Yes. Quotes are 100% free, no obligation, and never affect your credit. Brokers are paid by the carrier when a policy is issued—not by you.",
  },
  {
    q: "Do I need a medical exam?",
    a: "Some policies require one, but many top carriers now offer 'no-exam' (accelerated underwriting) options that can issue in days—not weeks. Darryl matches you to the right path based on your health and budget.",
  },
  {
    q: "What's the difference between term and permanent insurance?",
    a: "Term covers you for a set period (10–30 years) and is the most affordable. Permanent (whole life, IUL) lasts your lifetime and builds cash value you can borrow against. Many clients use both.",
  },
  {
    q: "Can I get coverage with pre-existing conditions?",
    a: "Often yes. Different carriers underwrite differently—one company may decline you while another approves at standard rates. As an independent broker, Darryl shops the market to find your best option.",
  },
  {
    q: "How fast can I get coverage?",
    a: "Some accelerated underwriting policies can issue in as little as 24–72 hours. Traditional underwriting with a medical exam typically takes 2–4 weeks.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-32 bg-pp-bone"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-pp-forest">
            Frequently asked
          </span>
          <h2 className="mt-4 font-serif font-medium text-4xl sm:text-5xl tracking-tight text-pp-forest-deep">
            Questions, answered honestly.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-pp-border-subtle rounded-2xl px-6 sm:px-8"
            >
              <AccordionTrigger className="text-left font-serif text-xl text-pp-forest-deep py-6 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-pp-text-secondary leading-relaxed pb-6 text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
